import React from 'react';
import SkeletonPage from './skeletons/SkeletonPage';

function Loading() {
  return <SkeletonPage />;
}

export default Loading;
